<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" class="pt-0 py-0" v-if="showTitle">
      <span class="headline">Geräte</span>
    </v-col>
    <v-col cols="12" class="py-0" v-if="!this.isCompanyView">
      <v-checkbox outlined v-model="showAll" class="mx-2" label="Alle anzeigen" @change="onChangeAll"></v-checkbox>
    </v-col>
    <v-col cols="4" xs="4">
      <v-select
          v-model="filterTags"
          :items="tags"
          outlined
          chips
          value="fred"
          deletable-chips
          small-chips
          @change="reFilter"
          label="Gruppe"
          multiple
      ></v-select>
    </v-col>
    <v-col cols="8" xs="2" md="2" align="start" class="pt-7">
      <span>Anzahl: {{stats.cnt}} / (<span style="color: red" title="Anzahl offline">{{stats.cntOffline}}</span> / <span style="color:green" title="Anzahl online">{{stats.cntOnline}}</span>  )</span>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="8" xs="8" md="3">
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          clearable
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12">

      <v-data-table
          :headers="headers"
          :items="deviceList"
          :search="search"
          show-select
          fixed-header
          :height="tableHeight"
          sort-by="indicatorSort"
          sort-desc
          v-model="selected"
          hide-default-footer
          hide-details
          :items-per-page="-1"

      >

        <template v-slot:item.indicatorSort="{ item }">
          <div :title="'Screen '+ item.screenNumber">
          <v-icon small :style="getIndicatorStyle(item)">lens</v-icon>
          <span class="handpointer" @click="editItem(item)"> {{ item.deviceState }}</span>
          </div>
        </template>
        <template v-slot:item.deviceState="{ item }">
          <v-icon small :style="getIndicatorStyle(item)">lens</v-icon>
          <span class="handpointer" @click="editItem(item)"> {{ item.deviceState }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span @click="editItem(item)" class="handpointer"> {{item.name}}</span>
        </template>
        <template v-slot:item.androidId="{ item }">
          <span> {{ item.androidId }} / {{ item.remoteAddress }}</span>
        </template>
        <template v-slot:item.clientVersionString="{ item }">
          <span class="handpointer"
                @click="editItem(item)"> {{ item.clientVersionString }} / {{ item.setClientVersion }}</span>
        </template>
        <template v-slot:item.diskUsageCurrent="{ item }">
          <span
              :style="getHDStyle(item)">{{
              toMB(item.diskUsageCurrent, 2)
            }}</span><span> von {{ toMB(item.diskUsageMax, 2) }}</span>
        </template>
        <template v-slot:item.lastHeartbeat="{ item }">
          <span>{{ tableUtils.convertToDateTime(item.lastHeartbeat) }} </span><br>
        </template>

        <template v-slot:item.tags="{ item }">
          <v-chip v-for="(c,i) in getTags(item)" :key="i">
            {{ c }}
          </v-chip>
        </template>
        <template v-slot:item.company="{ item }">
          <span v-if="item.companyName" @click="openCompany(item)">{{ item.companyName }}</span>
          <span v-if="!item.companyName" class="handpointer" :style="getCompanyStyle(item)" @click="openCompanyDialog(item)">zuweisen</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="previewItem(item)"
          >
            visibility
          </v-icon>
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
    <DialogSendEmail ref="dlgEMail" @sendMail="doSendMail"></DialogSendEmail>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";
import DialogSendEmail from "@/components/dialogs/DialogSendEmail";
import tableUtils from "@/components/tables/TableUtils";

var _ = require('lodash')
export default {
  name: 'TableApps',
  props: {
    companyId: String,
    showTitle: Boolean,
    isCompanyView: Boolean
  },
  components: {DialogSendEmail, DialogLinkCompany, DialogDeleteItem},
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Gerät',
        id: '' + item.guid,
        name: 'Gerät ' + item.name,
        item: item
      })
    },
    doSendMail: function (item) {
      console.log('doSendMail', item)
      var mail = null
      var cmp = this
      if (item.extra) {
        mail = []
        _.forEach(item.extra, function (device) {
          if (device.checked) {
            var txt = '<br><br>'
            _.forEach(device.devices, function (d) {
              txt += d.name + '\n<br>'
            })
            const newMessage = item.message.replace("[EXTRA_DATA]", txt)
            const m = {
              to: device.mail,
              subject: item.subject,
              message: newMessage,
              deviceCompanyGuid: device.guidCompany,
              deviceGuid: device.guidDevice,
              guidCompany: cmp.companyId,
            }
            mail.push(m)
          }
        })
      } else {
        mail = {
          to: item.to,
          subject: item.subject,
          message: item.message,
          guidCompany: item.item && item.item.guidCompany,
          deviceGuid: item.item && item.item.guid
        }
      }
      console.log('mail', mail)

      Vue.prototype.$api.sendMail(mail, function (res) {
        console.log('sendMail done', res)
      })
    },

    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$api.deleteDevice(item.item.guid, this.reload)
    },
    openCompany: function (item) {
      console.log('openCompany', item)
      const cmp = this
      Vue.prototype.$apiCompany.loadCompany(item.guidCompany, function (cdata) {
        if (cdata.guidParent) {
          cmp.$router.push('/Netzwerke/' + cdata.guidParent)
        } else {
          cmp.$router.push('/Netzwerke/' + cdata.guid)
        }
      })
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    sendEmail: function (item) {
      console.log('sendEmail', item)
      let devicePerCompany = {}
      const cmp = this
      _.forEach(this.deviceList, function (device) {
        const index = cmp.getIndicatorIndex(device)
        if (index === 2) {
          if (!devicePerCompany['' + device.guidCompany]) {
            devicePerCompany['' + device.guidCompany] = {
              name: device.companyName,
              mail: device.companyMail,
              guid: device.guidCompany,
              guidDevice: device.guid,
              devices: []
            }
          }
          devicePerCompany['' + device.guidCompany].devices.push(device)
        }
      })
      const mail = {
        subject: 'Geräte sind offline bitte Prüfen',
        message: 'bitte prüfen Sie folgende Geräte:\n\n[EXTRA_DATA]',
        extra: devicePerCompany
      }
      console.log('mail', mail, devicePerCompany)

      this.$refs.dlgEMail.open(mail)
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.deviceGuid, item, this.reload)
    },
    onChangeAll: function () {
      Vue.prototype.storage.saveState('deviceShowAll', this.showAll)
      this.reload()
    },
    previewItem: function (item) {
      window.open(Vue.prototype.$config.HOST + '/#/preview/' + item.guid, '_new')
    },
    editItem: function (item) {
      if (this.companyId && item.guidCompany) {
        this.$router.push('/Netzwerke/' + item.guidCompany + '/Geraete/' + item.guid)
      } else {
        this.$router.push('/Geraete/' + item.guid)
      }

    },
    getIndicatorIndex: function (item) {
      const diff = new Date().getTime() - item.lastHeartbeat
      if (diff >= 60 * 24 * 60000) {
        return 2
      }
      return 0
    },
    getIndicatorStyle: function (item) {
      const index = item.indicator
      if (index === 0) {
        return 'color: green;'
      } else if (index === 1) {
        return 'color: yellow;'
      } else if (index === 2) {
        return 'color: red;'
      }
      return ''
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    getTags: function (item) {
      return tableUtils.getTags(item);
    },
    reload: function () {
      if (this.companyId != null) {
        Vue.prototype.$api.loadDevicesFromCompany(this.companyId, this.onGetData)
      } else {
        Vue.prototype.$api.loadDevices(null, this.onGetData)
      }

    },
    doFilter: function (item) {
      let ok = true
      if (!this.showAll) {
        ok = (item.deviceState !== 'ACTIVE') && (item.deviceState !== 'VER')
      } else {
        ok = (item.deviceState !== 'VER')
      }
      if (this.filterTags && this.filterTags.length > 0) {
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        ok = ok && (found)
      }
      return ok
    },
    reFilter: function () {
      const cloneList = _.clone(this.completeData)
      this.deviceList = _.filter(cloneList, this.doFilter);
    },
    resize: function () {
      this.tableHeight = window.innerHeight - 546;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 416;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    onGetData: function (result) {
      this.stats = {
        cnt: 0,
        cntOffline: 0,
        cntOnline: 0
      }
      console.log('result', result)
      if (this.showAll) {
        this.deviceList = result
      } else {
        var res = []
        for (var i in result) {
          var item = result[i]
          if (!item.companyName) {
            res.push(item)
          }
        }
        this.deviceList = res
      }
      this.completeData = _.clone(result)
      let map = []
      let indexItem = 0
      for (var ii in result) {
        let item = result[ii]
        item.id = indexItem
        var t = JSON.parse(item.tags)
        item.tagArray = t
        for (var index in t) {
          let tag = t[index]
          map[tag] = tag
        }
        item.indicatorSort = this.getIndicatorIndex(item) + "_" + item.companyName
        item.indicator = this.getIndicatorIndex(item)
        this.stats.cnt += 1
        if (item.indicator === 2) {
          this.stats.cntOffline += 1
        } else {
          this.stats.cntOnline += 1
        }

        indexItem++
      }
      this.tags = Object.keys(map)
      this.reFilter()

    }
  },
  data() {
    return {

      currentDevice: null,
      search: null,
      tableHeight: 200,
      showAll: false,
      stats: {
        cnt: 0,
        cntOffline: 0,
        cntOnline: 0
      },
      selected: [],
      tags: [],
      tableUtils: require('./TableUtils').default,
      filterTags: [],
      headers: [
        {text: 'Status', value: 'indicatorSort'},
        {text: 'Name', align: 'left', value: 'name'},
        /* {text: 'Android Id', align: 'left', value: 'androidId'}, */
        {text: 'Playlist', align: 'left', value: 'playlistName'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        {text: 'Client Version', value: 'clientVersionString'},
        {text: 'Tags', value: 'tags'},
        {text: 'HD Kapazität', value: 'diskUsageCurrent'},
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'lastHeartbeat'},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        /*{text: 'Netzwerk', value: 'company'},*/
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: []
    }
  },
  mounted() {
    if (this.isCompanyView) {
      this.showAll = true
    } else {
      this.showAll = Vue.prototype.storage.getState('deviceShowAll')
    }
    if (this.showAll) {
      this.headers = [
        {text: 'Status', value: 'indicatorSort'},
        {text: 'Name', align: 'left', value: 'name'},
        /* {text: 'Android Id', align: 'left', value: 'androidId'}, */
        {text: 'Playlist', align: 'left', value: 'playlistName'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        {text: 'Client Version', value: 'clientVersionString'},
        {text: 'Tags', value: 'tags'},
        /*{text: 'HD Kapazität', value: 'diskUsageCurrent'},*/
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'lastHeartbeat'},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        {text: 'Standort', value: 'company'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ]
    }

    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  },
}
</script>

<style scoped>

</style>
